import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ColumnFilterChecklist, ColumnFilterDate} from '../ColumnFilter';
import {_MatMenu} from '@angular/material/menu';

@Component({
  selector: 'app-filter-component',
  templateUrl: './filter-component.component.html',
  styleUrls: ['./filter-component.component.css']
})
export class FilterComponentComponent implements OnInit {

  @Input() columnFilterCheck?: ColumnFilterChecklist<any>;
  @Input() columnFilterDate?: ColumnFilterDate<any>;
  @Output() onChange = new EventEmitter<void>();

  @ViewChild('menuFilterDate', {static: true}) mMenuFilterDate!: _MatMenu;
  @ViewChild('menuFilterCheck', {static: true}) mMenuFilterCheck!: _MatMenu;
  @ViewChild('menuEmpty', {static: true}) mMenuEmpty!: _MatMenu;

  constructor() { }

  ngOnInit(): void {

  }

  get buttonIconColor(): 'red' | 'white' {
    if (this.columnFilterDate)
      return this.columnFilterDate.isFiltering ? 'red' : 'white';
    else if (this.columnFilterCheck)
      return this.columnFilterCheck.allSelected ? 'white' : 'red';
    return 'white';
  }

  get matMenu(): _MatMenu {
    if (this.columnFilterCheck)
      return this.mMenuFilterCheck;
    else if (this.columnFilterDate)
      return this.mMenuFilterDate;
    return this.mMenuEmpty;
  }

}
